
export default function PricingSection() {
 
 return (
      <section className="pb-16 bg-white min-h-screen">
        <div style={{ minHeight: '300px' }}>
          <div data-mariana-integrations="/buy/48717"></div>
        </div>
      </section>
  );
}
